<script lang="ts">
	//Design system components
	import { Container, Text } from '@Shelly/shelly-design-system';
	//Svelte hooks
	import { createEventDispatcher, getContext } from 'svelte';
	//Services
	import { format } from 'svelte-i18n';
	//Components
	import Duration from '../SchedulesHelpers/Duration.svelte';

	const scheduleStore: SvelteStore<any> = getContext('schedule');

	let duration = $scheduleStore.duration;

	const dispatch = createEventDispatcher();
	const changeDuration = (e) => {
		duration = e.detail.duration;
		dispatch('update', e.detail);
	};
</script>

<Container padding="scrollPaddings">
	<Text class="mb-m" element="h2">
		{$format('set_duration_in_sec')}
	</Text>
	<Duration bind:value={duration} on:valueChange={changeDuration} />
</Container>
